import apiClient from '../client';

export interface EbayConnectionStatus {
  connected: boolean;
  userName?: string;
  expiresAt?: number;
}

export interface EbayAttachment {
  name: string;
  url: string;
}

export interface EbayMessage {
  id: string;
  externalMessageId?: string;
  subject: string;
  senderName: string;
  senderId: string;
  body: string;
  receivedAt: string;
  isRead: boolean;
  itemId?: string;
  itemTitle?: string;
  isSystemMessage: boolean;
  attachments: EbayAttachment[];
}

export interface EbayConversationTurn {
  id: string;
  externalMessageId?: string;
  direction: 'incoming' | 'outgoing';
  senderName: string;
  body: string;
  timestamp: string;
  attachments: EbayAttachment[];
  isRead: boolean;
}

export interface EbayConversation {
  key: string;
  buyerUsername: string;
  itemId?: string;
  itemTitle?: string;
  lastMessageAt: string;
  hasUnread: boolean;
  turns: EbayConversationTurn[];
}

export const marketplaceService = {
  async getEbayStatus(): Promise<EbayConnectionStatus> {
    const response: any = await apiClient.get('/marketplace/ebay/status');
    return response.data;
  },

  async getEbayAuthUrl(): Promise<string> {
    const response: any = await apiClient.get('/marketplace/ebay/auth-url');
    return response.data.url;
  },

  async getEbayMessages(): Promise<EbayMessage[]> {
    const response: any = await apiClient.get('/marketplace/ebay/messages');
    return response.data;
  },

  async getEbayConversations(): Promise<EbayConversation[]> {
    const response: any = await apiClient.get('/marketplace/ebay/conversations');
    return response.data;
  },

  async replyToEbayMessage(params: {
    itemId: string;
    parentMessageId: string;
    recipientId: string;
    body: string;
  }): Promise<void> {
    await apiClient.post('/marketplace/ebay/messages/reply', params);
  },

  async disconnectEbay(): Promise<void> {
    await apiClient.delete('/marketplace/ebay/disconnect');
  },
};
